// Override para fix de updatePricingQty - null safety
var _originalUpdatePricingQty = window.updatePricingQty;
window.updatePricingQty = function(qty) {
  try {
    _originalUpdatePricingQty(qty);
  } catch(e) {
    // Silencia el error de null match en productos sin formato de precio estándar
  }
};
